// extracted by mini-css-extract-plugin
var _1 = "getMagneticWallItemLayout-module__animatedBackground--auBIp";
var _2 = "-4px";
var _3 = "-13px";
var _4 = "34px";
export { _1 as "animatedBackground", _2 as "contentOffsetCompact", _3 as "contentOffsetFull", _4 as "minCommentHeight" }
